import moment from "moment-timezone";

export const getFootballDateRange = () => {
  const now = moment().tz("Asia/Yangon");
  const currentHour = now.hour(); // returns 0–23 as number
  console.log("Current Hour:", currentHour);

  if (currentHour > 12) {
    return now.format("YYYY-MM-DD");
  } else {
    return now.subtract(1, "day").format("YYYY-MM-DD");
  }
};
